module.exports = __webpack_public_path__ + "static/media/petits-pois.8d15e9e5.svg";